import api from "@/lib/api";

let scriptPromise = null;

// Loads Razorpay checkout.js once (idempotent).
export const loadRazorpayScript = () => {
  if (window.Razorpay) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = resolve;
    s.onerror = () => {
      scriptPromise = null;
      reject(new Error("Could not load Razorpay checkout"));
    };
    document.body.appendChild(s);
  });
  return scriptPromise;
};

let configPromise = null;

// Cached client-safe Razorpay config: { key_id, mock }. NEVER contains the secret.
export const getRazorpayConfig = () => {
  if (!configPromise) {
    configPromise = api
      .get("/config/razorpay")
      .then((r) => r.data)
      .catch((err) => {
        configPromise = null; // allow retry on next call
        throw err;
      });
  }
  return configPromise;
};
